import React from 'react';
import { BoxTitleStyled } from './styles';

export interface TitleProps {
  children: React.ReactNode;
  variant?: 'default' | 'page' | 'base';
}

const Title = ({ children, variant = 'default' }: TitleProps): JSX.Element => {
  return (
    <BoxTitleStyled variant={variant}>
      <h1>{children}</h1>
    </BoxTitleStyled>
  );
};

export default Title;
